var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 4C8.99999 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4C13 5.10457 12.1046 6 11 6C9.89543 6 8.99999 5.10457 8.99999 4ZM20 21.36L18.5 16.18C18.133 14.8885 16.9526 13.9981 15.61 14H13V11C13.7162 11.6319 14.635 11.9866 15.59 12H17.48C17.7561 12 17.98 11.7761 17.98 11.5V10.5C17.98 10.2239 17.7561 10 17.48 10H15.59C14.9174 9.99989 14.2899 9.66172 13.92 9.1L13.13 7.9C12.7601 7.33828 12.1326 7.00011 11.46 7H11C9.89543 7 8.99999 7.89543 8.99999 9V14.5C8.99999 15.3284 9.67157 16 10.5 16H15.23C15.902 16.0002 16.4931 16.4445 16.68 17.09L18 21.64C18.0622 21.8533 18.2578 22 18.48 22H19.48C19.7561 22 19.98 21.7761 19.98 21.5C19.9909 21.454 19.9976 21.4072 20 21.36ZM9.3447 19.9886C10.8613 19.8131 12.0043 18.5267 12 17H14C13.9995 19.6311 11.9599 21.8117 9.33466 21.9878C6.70943 22.1639 4.39689 20.2753 4.04493 17.6678C3.69297 15.0603 5.42203 12.6262 7.99999 12.1V14.18C6.5606 14.6889 5.73297 16.1977 6.0773 17.685C6.42164 19.1724 7.8281 20.164 9.3447 19.9886Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disabled.4843f879.svg";
export { ForwardRef as ReactComponent };